import { LinearProgress } from '@mui/material';

import { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import './App.css';
import DialogProvider from './components/DialogProvider';
import { useUser } from './hooks/useUser';

import './index.css';
import { useGetLatestAlertsQuery } from './services/fleetAnalytics/fleetAnalyticsApi';
import UserSnap from './components/UserSnap';
import { messages } from './locales/en/messages';
import useGoogleAnalytics from './hooks/useGoogleAnalytics';

import { i18n } from '@lingui/core';
i18n.load('en', messages);
i18n.activate('en');

function App() {
  const { isAuthenticated, isLoading, canSendFeedback, auth } = useUser();
  useGoogleAnalytics();

  // Provides navigate function globally (specially useful for legacy sagas and components)
  const navigate = useNavigate();
  useEffect(() => {
    window.navigate = navigate;
  }, [navigate]);

  const { data: alarms } = useGetLatestAlertsQuery(undefined, {
    skip: !isAuthenticated || isLoading,
    // pollingInterval: 10000,
  });

  return (
    <DialogProvider>
      {!!isLoading && <LinearProgress />}
      <Outlet />
      {canSendFeedback && (
        <UserSnap
          globalApiKey="6f32d02d-0a90-495c-b5af-0bcccc27c9a2"
          initialValues={{
            visitor: auth?.email || '',
          }}
          /* customValues={{ softwareVersion }} */
        />
      )}
    </DialogProvider>
  );

}

export default App;
